export enum EContentType {
	TEXT = "TEXT",
	IMAGE = "IMAGE",
	VIDEO = "VIDEO",
	EMBED = "EMBED",
}
